import React, { Component } from 'react';
import { 
    // AppProvider, Frame, Spinner 
} from '@shopify/polaris';
import './index.css';

class SkeltonSpinnerLoading extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        return (  
            
            <div className='Skelton_spinner_loading'>
                <title>Dropshipman</title>
                {/* <AppProvider> */}
                    {/* <div className='init_loading'>
                        <Frame>
                            <div className='install-loading-main' style={{textAlign: 'center',}}>
                                <img src='/Image/newlogo.png' style={{width: 80, height: 80}} alt='' />
                                <div style={{height: 30, width: '100%'}}></div>
                                <Spinner accessibilityLabel="Spinner example" size="large" />
                                <div style={{height: 30, width: '100%'}}></div>
                                <span style={{fontSize: 20}}>Welcome to SEOAnt, please wait patiently for the loading to complete</span>
                            </div>
                        </Frame>
                    </div> */}
                    <div id="loading-state" role="alert" aria-live="assertive">
                        <div className="message">
                        <img src="/new-product/loadingDsmText.svg" alt="Dropshipman Splash screen" width="120" height="120" />
                            <p>Welcome to Dropshipman, please wait patiently for the loading to complete</p>
                            <div className="content" aria-hidden="true">
                            <div className="spinner" aria-label="Loading">
                                <div></div>
                            </div>
                            </div>
                        </div>
                        </div>
                {/* </AppProvider> */}
            </div>

        );
    }
}

export default SkeltonSpinnerLoading;